import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";
import { MsoTable } from "./MsoTable";
import { ITableColumn } from "./ITableColumn";

export class ColumnButton extends ColumnBase {

    public constructor(table: MsoTable, def: ITableColumn, rootId: string) {
        super(table, def, rootId)
    }

    public getContent(row: any): HTMLElement {
        let button: HTMLButtonElement = <button
            type="button" className={`btn btn-mso ${(this.def.cssClass ? `${this.def.cssClass}` : "")}`}
            aria-label={this.def.inhaltText}>
            {this.def.inhaltText}
        </button>;
        button.setAttribute("data-id", row[this.table.props.idField]);

        return button;
    }

    public createCell(rowModel: any, idField: string): HTMLElement {
        const cell = super.createCell(rowModel, idField);
        cell.classList.add("mt-button");
        cell.classList.add("pointer");
        cell.setAttribute("data-id", rowModel[idField]);
        cell.addEventListener("click", this.onClickButton);
        return cell;
    }

    onClickButton = (ev: MouseEvent) => {
        if (this.table.props.onButtonClicked) {
            this.table.props.onButtonClicked((ev.currentTarget as HTMLElement).getAttribute("data-id"));
            ev.stopPropagation();
        }
    }

}